module.exports = __webpack_public_path__ + "img/clock.b233e97d.svg";